export default "__VITE_ASSET__D7TQ1P_t__"